import { rules, type schema } from "@/utils/validators";
import type { simulationFormData } from "../userManagement/components/userFormModal/types.props";

export const simulationSchema: schema<simulationFormData> = {
    name: [
        rules.required("El nombre del simulacro es requerido."),
        rules.minLength(3, "El nombre debe tener al menos 3 caracteres."),
    ],
    state: [
        rules.required("El estado es requerido."),
    ],
};
